import { useLingui } from '@lingui/react/macro';

import { DesktopEntityFilter } from '@/components/SharedFilters/EntityFilter/DesktopEntityFilter';
import IconPackage from '@/icons/Package.svg';

import { useFilters } from '../FiltersState';

export const FiltersStockLocation = ({ tag }: { tag?: boolean }) => {
  const { t } = useLingui();

  const {
    stockLocations: { stockLocations, setStockLocations },
  } = useFilters();

  const selectedStockLocationsCount = stockLocations.length;

  return (
    <DesktopEntityFilter
      selectedEntities={stockLocations}
      setSelectedEntities={setStockLocations}
      includeGroups={false}
      traits={['stockLocation']}
      tag={tag}
      label={t({ id: 'requests.filters.stock-location.label', message: 'Stock location' })}
      searchPlaceholder={t({
        id: 'requests.filters.stock-location.search.label',
        message: 'Search stock locations',
      })}
      icon={<IconPackage />}
      tagSelectedCountLabel={t({
        id: 'requests.filters.stock-location.multiple',
        message: `${selectedStockLocationsCount} stock locations`,
      })}
    />
  );
};
